export enum EMaintainerUrl {
  MAINTAINER = 'maintainer',
  INVITE = 'invite',
  PROPERTIES = 'properties',
  COMMUNICATION = 'communication',
  ASSIGNED = 'assigned',
  UNASSIGNED = 'unassigned',
}
